export class ObjectsCreatedResponse<T> {
  ids: T[]

  constructor(ids: T[]) {
    this.ids = ids
  }
}